














import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "InputRange",
  props: {
    min: { type: Number, default: 0 },
    max: { type: Number, default: 100 },
    step: { type: Number, default: 1 },
    value: { type: Number, default: 0 },
  },
});
